<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            v-if="detailInfo"
            title="Fresh Seed Bag"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div v-if="detailInfo">
            <p class="detail-title">Details</p>
            <el-steps class="stepper-container" :active="highlightedStep" align-center finish-status="success">
                <el-step v-for="(step, index) in steps" :key="'step' + index" :title="step.name" :description="step.description" />
            </el-steps>

            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    <tr>
                        <td>QR Code</td>
                        <td>{{ qrCode }}</td>
                    </tr>
                    <tr>
                        <td>Progeny</td>
                        <td>{{ (detailInfo.progeny||{}).code || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Cross Type</td>
                        <td>{{ ((detailInfo.progeny||{}).crossType||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Female</td>
                        <td>{{ femalePalm }}</td>
                    </tr>
                    <tr>
                        <td>Male</td>
                        <td>{{ malePalm }}</td>
                    </tr>
                    <tr>
                        <td>Moisture Content / %</td>
                        <td>{{ $_roundOfDecimal(detailInfo.mcFsStored, 2) || "-" }}</td>
                    </tr>
                    
                    <tr>
                        <td class="table-section" colspan="2">Status</td>
                    </tr>
                    <tr>
                        <td>Fresh Seed Status</td>
                        <td>{{ detailInfo.status || "-" }}</td>
                    </tr>

                    <tr>
                        <td class="table-section" colspan="2">Amount</td>
                    </tr>
                    <tr>
                        <td>Available</td>
                        <td>{{ detailInfo.totalFreshSeed || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Sent</td>
                        <td>{{ detailInfo.totalFreshSeedSend || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Discard</td>
                        <td>{{ detailInfo.totalDiscard || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Balance</td>
                        <td>{{ detailInfo.currentAmount || "-" }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Fresh Seed Bag Transaction</p>
            <fresh-seed-transaction-simple-table :id="detailInfo.id" />

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import { getFreshSeedBag } from "@/api/fresh_seed_bag";
import FreshSeedTransactionSimpleTable from "@/components/FreshSeedTransaction/FreshSeedTransactionSimpleTable";

export default {
    components: {
        "detail-header": DetailHeader,
        "fresh-seed-transaction-simple-table": FreshSeedTransactionSimpleTable,
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null,
            detailSteps: [
                { name: "Fungicide Treatment", dateKey: "fungicideTreamentDate", employeeKey: "" },
                { name: "Store", dateKey: "storeDate", employeeKey: "storeEmployee" },
                { name: "MC Test", dateKey: "testDate", employeeKey: "testEmployee" },
            ]
        };
    },
    computed: {
        qrCode() {
            return this.detailInfo.qrCode ? `${this.detailInfo?.qrCode?.code}` : "";
        },
        expireDate() {
            if (this.detailInfo.expireDate) {
                let days = this.$_getDaysFromDate(this.detailInfo.expireDate);
                let format_date = this.$_getMyrDateFormat(this.detailInfo.expireDate);
                return `${format_date} (${days})`;
            }
            else return "-";
        },
        femalePalm() {
            switch (this.detailInfo.discriminator) {
            case "FreshSeedBagOwn":
                return this.bunchInfo + "  | " + this.arrangePassportFormat(this.detailInfo?.bunch?.palm?.trial, this.detailInfo?.bunch?.palm?.trialPalmNumber, this.detailInfo?.bunch?.palm?.progeny);
            case "FreshSeedBagOutSource":
                return this.arrangePassportFormat(this.detailInfo?.progeny?.maternalPalm?.trial, this.detailInfo?.progeny?.maternalPalm?.trialPalmNumber, this.detailInfo?.progeny);
            default:
                return "---";
            }
        },
        malePalm() {
            switch (this.detailInfo.discriminator) {
            case "FreshSeedBagOwn":
                return this.pollenInfo + "  | " + this.arrangePassportFormat(this.detailInfo?.bunch?.pollenBottle?.pollen?.palm?.trial, this.detailInfo?.bunch?.pollenBottle?.pollen?.palm?.trialPalmNumber, this.detailInfo?.bunch?.pollenBottle?.pollen?.palm?.progeny);
            case "FreshSeedBagOutSource":
                return this.arrangePassportFormat(this.detailInfo?.progeny?.paternalPalm?.trial, this.detailInfo?.progeny?.paternalPalm?.trialPalmNumber, this.detailInfo?.progeny);
            default:
                return "---";
            }
        },
        steps() {
            return this.detailSteps.map(step => ({
                "name": step.name,
                "description": this.getRecordDateAndUser(this.detailInfo[step.dateKey], this.detailInfo[step.employeeKey]),
                "value": this.getIsHavingRecord(this.detailInfo[step.dateKey])
            }));
        },
        highlightedStep() {
            let lastHighlightedIndex = -1;
            this.steps.forEach((step, index) => {
                if (step.value === true) {
                    lastHighlightedIndex = index;
                }
            });
            return lastHighlightedIndex == -1 ? 0 : lastHighlightedIndex + 1;
        },
        bunchInfo() {
            return this.detailInfo?.bunch?.qrCode?.code || "-";
        },
        pollenInfo() {
            return this.detailInfo?.bunch?.pollenBottle?.pollen?.qrCode?.code || "-";
        }
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        getRecordDateAndUser(recordDate, recordUser) {
            let date = this.$_getMyrDateFormat(recordDate);
            let user = recordUser?.name || "-";
            return `${date} by ${user}`;
        },
        getIsHavingRecord(recordDate) {
            if (recordDate) {
                return true;
            }
            else return false;
        },
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await getFreshSeedBag({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        refreshDetailPage() {
            this.getDetails();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    }
};
</script>

<style scoped>
.stepper-container {
    padding: var(--space-16) 0;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/FreshSeedBagSidebar.vue